let mTheme = localStorage.getItem("Theme")

let LightModeFontColor = "#000000"
let LightModeBackgroundColor = "#FFFFFF"
let LightModeBackgroundColorSlightlyOff = "#F6F6F6"
let LightModeBorderColor = "#EEEEEE"
let LightModeHistoryBackgroundColor = LightModeBackgroundColor
let LightModeHistoryBackgroundColorHover = "#E0E0E0"
let LightModeHistoryBackgroundColorFocus = "#E8EBFA"
let LightModeHistoryBackgroundColorHoverFocus = "#9299F7"
let LightModeHistoryFontColorFocus = "#8F52B9"

let DarkModeFontColor = "#FFFFFF"
let DarkModeBackgroundColor = "#000000"
let DarkModeBackgroundColorSlightlyOff = "#161616"
let DarkModeBorderColor = "#292929"
let DarkModeHistoryBackgroundColor = DarkModeBackgroundColor
let DarkModeHistoryBackgroundColorHover = DarkModeBackgroundColor
let DarkModeHistoryBackgroundColorFocus = "#2F2F4A"
let DarkModeHistoryBackgroundColorHoverFocus = "#4F52B2"
let DarkModeHistoryFontColorFocus = "#7F85F5"

let CallButtonLight = true

//Call this function to override all themes with an existing color set
export function OverrideThemes(aFontColor,aBackgroundColor,aBackgroundColorSlightlyOff,aBorderColor,
    aHistoryBackgroundColor,aHistoryBackgroundColorHover,aHistoryBackgroundColorFocus,
    aHistoryBackgroundColorHoverFocus,aHistoryFontColorFocus, aCallButtonLight)
{
    LightModeFontColor = aFontColor
    DarkModeFontColor = aFontColor
    LightModeBackgroundColor = aBackgroundColor
    DarkModeBackgroundColor = aBackgroundColor
    LightModeBackgroundColorSlightlyOff = aBackgroundColorSlightlyOff
    DarkModeBackgroundColorSlightlyOff = aBackgroundColorSlightlyOff
    LightModeBorderColor = aBorderColor
    DarkModeBorderColor = aBorderColor
    LightModeHistoryBackgroundColor = aHistoryBackgroundColor
    DarkModeHistoryBackgroundColor = aHistoryBackgroundColor
    LightModeHistoryBackgroundColorHover = aHistoryBackgroundColorHover
    DarkModeHistoryBackgroundColorHover = aHistoryBackgroundColorHover
    LightModeHistoryBackgroundColorFocus = aHistoryBackgroundColorFocus
    DarkModeHistoryBackgroundColorFocus = aHistoryBackgroundColorFocus
    LightModeHistoryBackgroundColorHoverFocus = aHistoryBackgroundColorHoverFocus
    DarkModeHistoryBackgroundColorHoverFocus = aHistoryBackgroundColorHoverFocus
    LightModeHistoryFontColorFocus = aHistoryFontColorFocus
    DarkModeHistoryFontColorFocus = aHistoryFontColorFocus
    CallButtonLight = aCallButtonLight
}

export function OverrideThemesLight(aFontColor,aBackgroundColor,aBackgroundColorSlightlyOff,aBorderColor,
    aHistoryBackgroundColor,aHistoryBackgroundColorHover,aHistoryBackgroundColorFocus,
    aHistoryBackgroundColorHoverFocus,aHistoryFontColorFocus, aCallButtonLight)
{
    LightModeFontColor = aFontColor
    LightModeBackgroundColor = aBackgroundColor
    LightModeBackgroundColorSlightlyOff = aBackgroundColorSlightlyOff
    LightModeBorderColor = aBorderColor
    LightModeHistoryBackgroundColor = aHistoryBackgroundColor
    LightModeHistoryBackgroundColorHover = aHistoryBackgroundColorHover
    LightModeHistoryBackgroundColorFocus = aHistoryBackgroundColorFocus
    LightModeHistoryBackgroundColorHoverFocus = aHistoryBackgroundColorHoverFocus
    LightModeHistoryFontColorFocus = aHistoryFontColorFocus
    CallButtonLight = aCallButtonLight
}

export function OverrideThemesDark(aFontColor,aBackgroundColor,aBackgroundColorSlightlyOff,aBorderColor,
    aHistoryBackgroundColor,aHistoryBackgroundColorHover,aHistoryBackgroundColorFocus,
    aHistoryBackgroundColorHoverFocus,aHistoryFontColorFocus, aCallButtonLight)
{
    DarkModeFontColor = aFontColor
    DarkModeBackgroundColor = aBackgroundColor
    DarkModeBackgroundColorSlightlyOff = aBackgroundColorSlightlyOff
    DarkModeBorderColor = aBorderColor
    DarkModeHistoryBackgroundColor = aHistoryBackgroundColor
    DarkModeHistoryBackgroundColorHover = aHistoryBackgroundColorHover
    DarkModeHistoryBackgroundColorFocus = aHistoryBackgroundColorFocus
    DarkModeHistoryBackgroundColorHoverFocus = aHistoryBackgroundColorHoverFocus
    DarkModeHistoryFontColorFocus = aHistoryFontColorFocus
    CallButtonLight = aCallButtonLight
}

export function GetTheme()
{
  return mTheme
}

export function SetTheme(aTheme)
{
  mTheme = aTheme
  localStorage.setItem("Theme",aTheme)
}


export function ThemeBackgroundColor() 
{
    return mTheme === "dark" ? DarkModeBackgroundColor : LightModeBackgroundColor
}

export function ThemeBorderColor() 
{
    return mTheme === "dark" ? DarkModeBorderColor : LightModeBorderColor
}

export function ThemeCallButtonLight() 
{
    return CallButtonLight
}

export function ThemeFontColor() 
{
    return mTheme === "dark" ? DarkModeFontColor : LightModeFontColor
}

export function ThemeHistoryBackgroundColor() 
{
    return mTheme === "dark" ? DarkModeHistoryBackgroundColor : LightModeHistoryBackgroundColor
}

export function ThemeHistoryBackgroundColorHover() 
{
    return mTheme === "dark" ? DarkModeHistoryBackgroundColorHover : LightModeHistoryBackgroundColorHover
}

export function ThemeBackgroundColorSlightlyOff() 
{
    return mTheme === "dark" ? DarkModeBackgroundColorSlightlyOff : LightModeBackgroundColorSlightlyOff
}

export function ThemeHistoryBackgroundColorFocus() 
{
    return mTheme === "dark" ? DarkModeHistoryBackgroundColorFocus : LightModeHistoryBackgroundColorFocus
}

export function ThemeHistoryBackgroundColorHoverFocus() 
{
    return mTheme === "dark" ? DarkModeHistoryBackgroundColorHoverFocus : LightModeHistoryBackgroundColorHoverFocus
}

export function ThemeHistoryFontColorFocus() 
{
    return mTheme === "dark" ? DarkModeHistoryFontColorFocus : LightModeHistoryFontColorFocus
}